import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { showLoading, hideLoading } from 'react-redux-loading-bar'
import AdoptionMiddleware from '../modules/adoption/middleware'
import Breadcrumb from '../components/Breadcrumb'
import ActionAdoption from '../modules/adoption/actions'
import { withRouter } from 'react-router-dom'

const mapStateToProps = ({ adoption }) => ({
  segments: adoption.segments,
  filterGradeId: adoption.filterGradeId,
  grades: adoption.grades
})

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    fetchAllAdoption: () => AdoptionMiddleware.fetchAllAdoption(),
    fetchSegments: () => AdoptionMiddleware.fetchSegments(),
    setSelectedGrades: (grades) => ActionAdoption.setSelectedGrades(grades),
    setFilterGradeId: (param) => ActionAdoption.setFilterGradeId(param),
    showLoading: () => showLoading(),
    hideLoading: () => hideLoading()
  }, dispatch)
}

class BreadcrumbContainer extends Component {
  changeSelectSegment = (e) => {
    const { fetchAllAdoption, setFilterGradeId } = this.props
    setFilterGradeId(e.target.value)
    fetchAllAdoption()
  }

  componentDidMount () {
    const { fetchSegments } = this.props
    fetchSegments()
  }

  currentRootName () {
    // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
    const path = this.props.location.pathname
    switch (path) {
      case '/books':
        return 'Livros'
      case '/adoption':
        return 'Adoção'
      default:
        return ''
    }
  }

  render () {
    return (
      <Breadcrumb
        items={this.props.segments}
        changeSelectSegment={this.changeSelectSegment}
        root={this.currentRootName()}
        filterGradeId={this.props.filterGradeId}
      />
    )
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(BreadcrumbContainer))



// WEBPACK FOOTER //
// ./src/containers/BreadcrumbContainer.js